/**
 * ============================================================
 * ListItem.js — Reusable Row Item for Add/Delete Lists
 * ============================================================
 *
 * A single row inside Admin form list sections such as:
 *   - People linked to a project
 *   - Publications linked to a project or person
 *   - Projects linked to a person or publication
 *
 * Features:
 *   - Displays a name/title
 *   - Optional inline edit block (e.g., position, faculty checkbox)
 *   - Optional "Add" icon (PlusCircleFill)
 *   - Optional "Delete" icon (XCircleFill)
 *
 * Props:
 *   - name            (string)   — display name of the item
 *   - onClick         (function) — handler for add/remove click
 *   - backgroundColor (string)   — optional row background color
 *   - isAdd           (boolean)  — if true, shows + icon
 *   - isDelete        (boolean)  — if true, shows X icon
 *   - edit            (JSX)      — optional inline edit UI block
 *
 * Notes:
 *   - Icons come from react-bootstrap-icons
 *   - Used heavily in Admin forms for relational linking
 **/

import React from "react";
import { XCircleFill, PlusCircleFill } from "react-bootstrap-icons";

import "./css/AdminComponents.css";


// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
const ListItem = ({
  name,
  onClick,
  backgroundColor,
  isAdd,
  isDelete,
  edit,
}) => {
  const styles = {
    container: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "1rem",
      borderBottom: "1px solid #ccc",
      borderTop: "1px solid #ccc",
      backgroundColor,
    },
    title: {
      fontSize: "1.2rem",
      margin: 0,
    },
  };

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------
  return (
    <div
      className="admin-listitem-container"
      style={{ backgroundColor }}   /* background is dynamic */
    >
      <p className="admin-listitem-title">{name}</p>

      {/* ----- INLINE EDIT UI ----- */}
      <div>{edit}</div>

      {/* ----- ADD / DELETE ICONS ----- */}
      <div>
        {isAdd && <PlusCircleFill onClick={onClick} />}
        {isDelete && <XCircleFill onClick={onClick} />}
      </div>
    </div>
  );
};

export default ListItem;
